// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-dataview.p-dataview-list .p-dataview-content > .p-grid > div {\n  border: solid #dee2e6;\n  border: none;\n}", "",{"version":3,"sources":["webpack://src/pages/atendimentos/atendimento.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;AACd","sourcesContent":[".p-dataview.p-dataview-list .p-dataview-content > .p-grid > div {\n  border: solid #dee2e6;\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
